import React, { useEffect, useState } from 'react';

interface AudioProps {
	title: string;
	volume: string;
	setVolume: any;
	mute: boolean;
	setMute: any;
	setMusicHandler: any;
}
export default function VolumeBar({
	title,
	setVolume,
	volume,
	mute,
	setMute,
	setMusicHandler
}: AudioProps) {
	const [value, setValue] = useState<string>(volume);
	const [trackWidth, setTrackWidth] = useState<number>(Number(volume));

	const handleChange = (e: any) => {
		const val = e.target ? e.target.value : e;
		setValue(val);
		setVolume(val);
		setTrackWidth(Number(val));
		Number(val) === 0 ? setMute(true) : setMute(false);
	};

	useEffect(() => {
		setValue(volume);
		setTrackWidth(Number(volume));
	}, [volume]);

	const thumbLeft = trackWidth <= 5 ? '2%' : trackWidth >= 95 ? '98%' : `${trackWidth}%`;

	return (
		<>
			<input
				type={'range'}
				min={0}
				max={100}
				step={1}
				value={value}
				onChange={(e) => handleChange(e)}
				onMouseUp={setMusicHandler}
				onTouchEnd={setMusicHandler}
			/>
			<div
				id='track'
				style={{
					opacity: `${mute ? '40%' : '100%'}`
				}}
			>
				<div id='track-inner' className={`track-inner-${title}`} style={{ width: `${trackWidth}%` }}></div>
				<div
					id='thumb'
					className={`thumb-${title}`}
					style={{ left: thumbLeft }}
				>
					<span />
				</div>
				<div id='track-outter' className={`track-outter-${title}`} style={{ width: `${100 - trackWidth}%` }}></div>
			</div>
		</>
	);
}
